<ng-container *transloco="let t">
  <app-admin-card-with-title
    [cardTitle]="t('race.pricing.additionalItems')" [showToggleButton]="true"
    [isContentVisible]="!additionalPricingItemsCollapsed">
    <div slot="trailingWidget">
      <div class="pe-4">
        <app-rounded-button [label]="t('race.pricing.add.additional.item')" (onClick)="openEditModal()"
                            [isDisabled]="disableEditing" [btnClass]="'rounded-button--solid'"><i
          class="bi bi-plus-circle pe-2"></i></app-rounded-button>
      </div>
    </div>
    @if (raceAdditionalItems.length > 0) {
      <table class="table dark-header table-last-row-no-border" infinite-scroll [infiniteScrollDistance]="4">
        <thead>
        <tr>
          <th>{{ t("race.pricing.additional.items.displayName") }}</th>
          <th>{{ t("race.pricing.additional.items.internalDescription") }}</th>
          <th>({{ t("race.pricing.additional.items.priceWithVAT") }})</th>
          <th class="more-column-width"></th>
        </tr>
        </thead>
        <tr app-table-header-separator></tr>
        <tbody>
          @for (raceAdditionalItem of raceAdditionalItems;track raceAdditionalItem) {
            <tr>
              <td class="center-align fw-semibold">
                <app-language-output [hrLabel]="raceAdditionalItem.name" [enLabel]="raceAdditionalItem.nameEng"
                                     [srLabel]="raceAdditionalItem.nameSr"
                                     [bsLabel]="raceAdditionalItem.nameBs"
                                     [itLabel]="raceAdditionalItem.nameIta" [siLabel]="raceAdditionalItem.nameSlo"
                                     [defaultLanguage]="event?.defaultLanguage" [languages]="languages"/>
              </td>
              <td class="center-align">{{ raceAdditionalItem.internalDescription ?? "-" }}</td>
              <td class="center-align">
                @if (raceAdditionalItem.priceConstant || (raceAdditionalItem.pricingItemValues?.length ?? 0) == 0) {
                  <span>{{ raceAdditionalItem.price | myCurrency:getCurrencyLabel() }}</span>
                } @else {
                  <span>
                    @for (pricingItem of raceAdditionalItem.pricingItemValues;track pricingItem;let i = $index) {
                      <span> {{
                        (pricingItem.price | myCurrency:getCurrencyLabel()) + (i <
                        (raceAdditionalItem.pricingItemValues!.length - 1) ? ", " : "")
                      }}</span>
                    }
                  </span>
                }
              </td>

              <td class="text-end center-align">
                @if (!disableEditing) {
                  <div ngbDropdown class="dropdown dropdown--remove-arrow" container="body">
                  <span class="menu-icon" id="eventActionsDropdown" ngbDropdownToggle>
                    <i class="fas fa-ellipsis-v"></i>
                  </span>
                    <ul aria-labelledby="eventActionsDropdown" ngbDropdownMenu>
                      <li ngbDropdownItem (click)="openEditModal(raceAdditionalItem)" class="cursor-pointer">{{
                          t("app.common.edit")
                        }}
                      </li>
                      <li ngbDropdownItem (click)="onDeleteRaceAdditionalPricingItem(raceAdditionalItem)"
                          class="cursor-pointer">{{
                          t("app.common.delete")
                        }}
                      </li>
                    </ul>
                  </div>
                }
              </td>
            </tr>
          }
        </tbody>
      </table>
    } @else {
      <div class="my-3">
        <app-empty-state-admin/>
      </div>
    }
  </app-admin-card-with-title>
</ng-container>
